import React, { type FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { type Theme } from '@mui/material/styles'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { AddButtonContainer } from '../../meter/filters/Filters.style'
import Add from '@mui/icons-material/Add'
import { CustomerListContainer } from './CustomersView.style'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { FetchCompanyUsersAction, OpenEditCompanyDialogAction } from '../../../redux/admin/admin-companies-actions'
import { type RootState } from '../../../redux/store'
import { type AdminCompany, type SelectedOrganization } from '../../../redux/admin/admin-companies-types'

/* Constants */
const useStyles = makeStyles()((theme: Theme) => {
  return {
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      maxWidth: '100%',
      position: 'relative',
      overflow: 'auto',
      maxHeight: 300,
      border: 'solid #EFF0F3 1px',
      borderRadius: '5px'
    }
  }
})

const emptyNewCompany: SelectedOrganization = {
  id: '',
  name: '',
  vatId: '',
  streetAddress: '',
  town: '',
  postalCode: '',
  newCompany: true
}

/**
 * Customers list component.
 */
export const CustomersList: FC = () => {
  const dispatch = useAppDispatch()

  const { classes } = useStyles()
  const searchedCompanies = useAppSelector<AdminCompany[]>((state: RootState) => state.admin.searchedCompanies)

  const createCompany = (): void => {
    const newCompany: SelectedOrganization = {
      ...emptyNewCompany
    }
    dispatch(OpenEditCompanyDialogAction({ company: newCompany, startInEditMode: true }))
  }

  const onEditCompany = (company: AdminCompany): void => {
    const editedCompany: SelectedOrganization = {
      ...company,
      newCompany: false
    }
    dispatch(FetchCompanyUsersAction({ companyId: company.id }))
    dispatch(OpenEditCompanyDialogAction({ company: editedCompany, startInEditMode: false }))
  }

  return (
        <CustomerListContainer>
            <List className={classes.root}>
                {searchedCompanies.map((company) => (
                    <ListItem key={company.id} button onClick={() => {
                      onEditCompany(company)
                    }}>
                        <ListItemText primary={company.name}/>
                    </ListItem>
                ))}
            </List>
            <AddButtonContainer
                aria-controls='add-company-button'
                aria-haspopup={true}
                style={{ justifySelf: 'end' }}
                onClick={createCompany}
            >
                <Add style={{ color: '#ffffff', alignSelf: 'center', margin: 'auto' }}/>
            </AddButtonContainer>
        </CustomerListContainer>

  )
}
